const termsContent = {
  en: {
    title: 'Terms of Service',
    effectiveDate: 'Effective Date: March 4, 2026',
    intro: 'Welcome to My Personal Plant Inventory ("the App"). By accessing or using this application, you agree to be bound by these Terms of Service. If you do not agree, please do not use the App.',
    sections: [
      {
        title: '1. Description of Service',
        paragraphs: ['My Personal Plant Inventory is a free web application that allows users to photograph, identify, and catalog houseplants. The App uses Google Gemini AI for plant identification and stores all user data in the user\'s own Google Drive account or locally on their device.'],
      },
      {
        title: '2. Account and Authentication',
        paragraphs: ['To use the full App, you may sign in with a Google account. By signing in, you authorize the App to:'],
        items: [
          'Access your basic Google profile information for authentication purposes.',
          'Create and manage files in your Google Drive within a folder called "PlantInventory."',
        ],
        afterItems: 'You are responsible for maintaining the security of your Google account.',
      },
      {
        title: '3. Data Storage and Ownership',
        paragraphs: ['All plant data and photos are stored exclusively in your personal Google Drive account or in your browser\'s local storage. We do not store your plant data or photos on our servers. The only data we store on our servers is:'],
        items: [
          'Your basic profile information (for session management).',
          'Your Google Drive OAuth tokens (for maintaining your Drive connection).',
        ],
        afterItems: 'You retain full ownership and control of all your plant data and photos at all times.',
      },
      {
        title: '4. AI Plant Identification',
        paragraphs: ['The App uses Google Gemini AI to identify plants from photos. Please note:'],
        items: [
          'AI identification may not always be accurate.',
          'The App does not guarantee the correctness of identifications or care recommendations.',
          'Do not rely solely on this App for decisions related to plant safety, toxicity, or edibility.',
          'Photos submitted for identification are processed by Google\'s Gemini API.',
        ],
      },
      {
        title: '5. Acceptable Use',
        paragraphs: ['You agree to use the App only for its intended purpose. You agree not to:'],
        items: [
          'Attempt to reverse-engineer, decompile, or disassemble the App.',
          'Upload content that is illegal, harmful, or violates the rights of others.',
          'Interfere with or disrupt the App\'s functionality.',
          'Use automated tools, bots, or scrapers to access the App.',
        ],
      },
      {
        title: '6. Intellectual Property',
        paragraphs: ['The App, including its design, code, and branding (excluding user-generated content), is the intellectual property of the App\'s creator. You are granted a limited, non-exclusive, non-transferable license to use the App for personal, non-commercial purposes.'],
      },
      {
        title: '7. Third-Party Services',
        paragraphs: ['The App integrates with Google Sign-In, Google Drive API, and Google Gemini AI. Your use of these services is subject to their respective terms and privacy policies.'],
      },
      {
        title: '8. Disclaimer of Warranties',
        paragraphs: ['The App is provided "as is" and "as available" without warranties of any kind. We do not warrant that:'],
        items: [
          'The App will be uninterrupted, secure, or error-free.',
          'AI identifications or care recommendations will be accurate.',
          'Data stored in your Google Drive will be preserved.',
        ],
      },
      {
        title: '9. Limitation of Liability',
        paragraphs: ['To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the App, inaccurate identifications, unauthorized access, or third-party service disruptions.'],
      },
      {
        title: '10. Changes',
        paragraphs: ['We reserve the right to modify, suspend, or discontinue the App at any time. We may update these Terms from time to time; your continued use constitutes acceptance.'],
      },
      {
        title: '11. Termination',
        paragraphs: ['You may stop using the App at any time. We may terminate or suspend your access at our sole discretion. Upon termination, your data remains in your Google Drive under your control.'],
      },
      {
        title: '12. Contact',
        paragraphs: ['If you have any questions about these Terms, please contact us through the application.'],
      },
    ],
  },
  es: {
    title: 'T\u00e9rminos de Servicio',
    effectiveDate: 'Fecha de vigencia: 4 de marzo de 2026',
    intro: 'Bienvenido a Mi Inventario Personal de Plantas ("la App"). Al acceder o usar esta aplicaci\u00f3n, aceptas estos T\u00e9rminos de Servicio. Si no est\u00e1s de acuerdo, por favor no uses la App.',
    sections: [
      {
        title: '1. Descripci\u00f3n del Servicio',
        paragraphs: ['Mi Inventario Personal de Plantas es una aplicaci\u00f3n web gratuita que permite fotografiar, identificar y catalogar plantas. Usa la IA Google Gemini para la identificaci\u00f3n y almacena datos en Google Drive o localmente.'],
      },
      {
        title: '2. Cuenta y Autenticaci\u00f3n',
        paragraphs: ['Para usar la App completa, puedes iniciar sesi\u00f3n con una cuenta de Google. Al hacerlo, autorizas a la App a:'],
        items: [
          'Acceder a tu informaci\u00f3n b\u00e1sica de perfil de Google para autenticaci\u00f3n.',
          'Crear y gestionar archivos en tu Google Drive en una carpeta llamada "PlantInventory".',
        ],
        afterItems: 'Eres responsable de mantener la seguridad de tu cuenta de Google.',
      },
      {
        title: '3. Almacenamiento y Propiedad de Datos',
        paragraphs: ['Todos los datos y fotos de plantas se almacenan exclusivamente en tu cuenta personal de Google Drive o en el almacenamiento local de tu navegador. Solo almacenamos en nuestros servidores:'],
        items: [
          'Tu informaci\u00f3n b\u00e1sica de perfil (para gesti\u00f3n de sesi\u00f3n).',
          'Tus tokens OAuth de Google Drive (para mantener la conexi\u00f3n).',
        ],
        afterItems: 'Conservas la propiedad y control total de todos tus datos y fotos en todo momento.',
      },
      {
        title: '4. Identificaci\u00f3n de Plantas con IA',
        paragraphs: ['La App usa la IA Google Gemini para identificar plantas. Ten en cuenta:'],
        items: [
          'La identificaci\u00f3n por IA puede no ser siempre precisa.',
          'La App no garantiza la exactitud de las identificaciones o recomendaciones de cuidado.',
          'No conf\u00edes \u00fanicamente en esta App para decisiones sobre seguridad, toxicidad o comestibilidad.',
          'Las fotos enviadas son procesadas por la API de Google Gemini.',
        ],
      },
      {
        title: '5. Uso Aceptable',
        paragraphs: ['Aceptas usar la App solo para su prop\u00f3sito previsto. Aceptas no:'],
        items: [
          'Intentar descompilar o desensamblar la App.',
          'Subir contenido ilegal, da\u00f1ino o que viole derechos de terceros.',
          'Interferir con la funcionalidad de la App.',
          'Usar herramientas automatizadas, bots o scrapers.',
        ],
      },
      {
        title: '6. Propiedad Intelectual',
        paragraphs: ['La App es propiedad intelectual de su creador. Se te otorga una licencia limitada, no exclusiva e intransferible para uso personal y no comercial.'],
      },
      {
        title: '7. Servicios de Terceros',
        paragraphs: ['La App se integra con Google Sign-In, Google Drive API y Google Gemini AI. Tu uso est\u00e1 sujeto a sus respectivos t\u00e9rminos.'],
      },
      {
        title: '8. Exenci\u00f3n de Garant\u00edas',
        paragraphs: ['La App se proporciona "tal cual" y "seg\u00fan disponibilidad" sin garant\u00edas. No garantizamos que:'],
        items: [
          'La App sea ininterrumpida, segura o libre de errores.',
          'Las identificaciones o recomendaciones de IA sean precisas.',
          'Los datos almacenados en Google Drive se conserven.',
        ],
      },
      {
        title: '9. Limitaci\u00f3n de Responsabilidad',
        paragraphs: ['En la m\u00e1xima medida permitida por la ley, no seremos responsables de da\u00f1os indirectos, incidentales, especiales o punitivos derivados del uso de la App.'],
      },
      {
        title: '10. Cambios',
        paragraphs: ['Nos reservamos el derecho de modificar, suspender o discontinuar la App en cualquier momento. El uso continuado constituye aceptaci\u00f3n.'],
      },
      {
        title: '11. Terminaci\u00f3n',
        paragraphs: ['Puedes dejar de usar la App en cualquier momento. Tus datos permanecen en tu Google Drive bajo tu control.'],
      },
      {
        title: '12. Contacto',
        paragraphs: ['Si tienes preguntas sobre estos T\u00e9rminos, cont\u00e1ctanos a trav\u00e9s de la aplicaci\u00f3n.'],
      },
    ],
  },
  fr: {
    title: 'Conditions d\'Utilisation',
    effectiveDate: 'Date d\'entr\u00e9e en vigueur : 4 mars 2026',
    intro: 'Bienvenue sur Mon Inventaire Personnel de Plantes ("l\'Application"). En acc\u00e9dant ou en utilisant cette application, vous acceptez ces Conditions d\'Utilisation.',
    sections: [
      {
        title: '1. Description du Service',
        paragraphs: ['Mon Inventaire Personnel de Plantes est une application web gratuite permettant de photographier, identifier et cataloguer des plantes. Elle utilise l\'IA Google Gemini et stocke les donn\u00e9es dans Google Drive ou localement.'],
      },
      {
        title: '2. Compte et Authentification',
        paragraphs: ['Pour utiliser l\'Application compl\u00e8te, vous pouvez vous connecter avec un compte Google. Ce faisant, vous autorisez l\'Application \u00e0 :'],
        items: [
          'Acc\u00e9der \u00e0 vos informations de profil Google pour l\'authentification.',
          'Cr\u00e9er et g\u00e9rer des fichiers dans un dossier "PlantInventory" de votre Drive.',
        ],
        afterItems: 'Vous \u00eates responsable de la s\u00e9curit\u00e9 de votre compte Google.',
      },
      {
        title: '3. Stockage et Propri\u00e9t\u00e9 des Donn\u00e9es',
        paragraphs: ['Toutes les donn\u00e9es sont stock\u00e9es dans votre Google Drive ou le stockage local. Nous stockons uniquement sur nos serveurs :'],
        items: [
          'Vos informations de profil (gestion de session).',
          'Vos tokens OAuth Google Drive (maintien de la connexion).',
        ],
        afterItems: 'Vous conservez la propri\u00e9t\u00e9 et le contr\u00f4le total de vos donn\u00e9es.',
      },
      {
        title: '4. Identification par IA',
        paragraphs: ['L\'Application utilise l\'IA Google Gemini. Veuillez noter :'],
        items: [
          'L\'identification peut ne pas toujours \u00eatre pr\u00e9cise.',
          'Aucune garantie d\'exactitude des identifications ou recommandations.',
          'Ne vous fiez pas uniquement \u00e0 cette Application pour la toxicit\u00e9 ou la comestibilit\u00e9.',
          'Les photos soumises sont trait\u00e9es par l\'API Google Gemini.',
        ],
      },
      {
        title: '5. Utilisation Acceptable',
        paragraphs: ['Vous acceptez de ne pas :'],
        items: [
          'Tenter de d\u00e9compiler ou d\u00e9sassembler l\'Application.',
          'T\u00e9l\u00e9charger du contenu ill\u00e9gal ou nuisible.',
          'Interf\u00e9rer avec la fonctionnalit\u00e9 de l\'Application.',
          'Utiliser des outils automatis\u00e9s, bots ou scrapers.',
        ],
      },
      {
        title: '6. Propri\u00e9t\u00e9 Intellectuelle',
        paragraphs: ['L\'Application est la propri\u00e9t\u00e9 intellectuelle de son cr\u00e9ateur. Vous b\u00e9n\u00e9ficiez d\'une licence limit\u00e9e pour un usage personnel et non commercial.'],
      },
      {
        title: '7. Services Tiers',
        paragraphs: ['L\'Application s\'int\u00e8gre avec Google Sign-In, Google Drive API et Google Gemini AI, soumis \u00e0 leurs conditions respectives.'],
      },
      {
        title: '8. Exclusion de Garanties',
        paragraphs: ['L\'Application est fournie "en l\'\u00e9tat". Nous ne garantissons pas :'],
        items: [
          'Un fonctionnement ininterrompu, s\u00e9curis\u00e9 ou sans erreur.',
          'La pr\u00e9cision des identifications ou recommandations IA.',
          'La conservation des donn\u00e9es dans Google Drive.',
        ],
      },
      {
        title: '9. Limitation de Responsabilit\u00e9',
        paragraphs: ['Nous ne serons pas responsables des dommages indirects, accessoires, sp\u00e9ciaux ou punitifs li\u00e9s \u00e0 l\'utilisation de l\'Application.'],
      },
      {
        title: '10. Modifications',
        paragraphs: ['Nous nous r\u00e9servons le droit de modifier l\'Application \u00e0 tout moment. Votre utilisation continue constitue une acceptation.'],
      },
      {
        title: '11. R\u00e9siliation',
        paragraphs: ['Vous pouvez cesser d\'utiliser l\'Application \u00e0 tout moment. Vos donn\u00e9es restent dans votre Google Drive.'],
      },
      {
        title: '12. Contact',
        paragraphs: ['Pour toute question, contactez-nous via l\'application.'],
      },
    ],
  },
  de: {
    title: 'Nutzungsbedingungen',
    effectiveDate: 'G\u00fcltig ab: 4. M\u00e4rz 2026',
    intro: 'Willkommen bei Mein Pers\u00f6nliches Pflanzeninventar ("die App"). Durch Zugriff oder Nutzung stimmen Sie diesen Nutzungsbedingungen zu.',
    sections: [
      {
        title: '1. Beschreibung des Dienstes',
        paragraphs: ['Mein Pers\u00f6nliches Pflanzeninventar ist eine kostenlose Web-App zum Fotografieren, Identifizieren und Katalogisieren von Pflanzen. Sie verwendet Google Gemini KI und speichert Daten in Google Drive oder lokal.'],
      },
      {
        title: '2. Konto und Authentifizierung',
        paragraphs: ['F\u00fcr die vollst\u00e4ndige Nutzung k\u00f6nnen Sie sich mit einem Google-Konto anmelden. Damit autorisieren Sie die App:'],
        items: [
          'Auf Ihre grundlegenden Google-Profilinformationen zuzugreifen.',
          'Dateien in einem Ordner "PlantInventory" in Ihrem Drive zu erstellen und zu verwalten.',
        ],
        afterItems: 'Sie sind f\u00fcr die Sicherheit Ihres Google-Kontos verantwortlich.',
      },
      {
        title: '3. Datenspeicherung und Eigentum',
        paragraphs: ['Alle Daten werden in Ihrem Google Drive oder lokalen Speicher gespeichert. Auf unseren Servern speichern wir nur:'],
        items: [
          'Ihre grundlegenden Profilinformationen (Sitzungsverwaltung).',
          'Ihre Google Drive OAuth-Tokens (Verbindungsaufrechterhaltung).',
        ],
        afterItems: 'Sie behalten jederzeit die volle Kontrolle \u00fcber Ihre Daten.',
      },
      {
        title: '4. KI-Pflanzenidentifikation',
        paragraphs: ['Die App verwendet Google Gemini KI. Bitte beachten Sie:'],
        items: [
          'Die KI-Identifizierung ist m\u00f6glicherweise nicht immer genau.',
          'Keine Garantie f\u00fcr die Richtigkeit von Identifizierungen oder Pflegeempfehlungen.',
          'Verlassen Sie sich nicht ausschlie\u00dflich auf diese App f\u00fcr Entscheidungen \u00fcber Toxizit\u00e4t oder Essbarkeit.',
          'Eingereichte Fotos werden von Googles Gemini API verarbeitet.',
        ],
      },
      {
        title: '5. Akzeptable Nutzung',
        paragraphs: ['Sie stimmen zu, die App nicht zu missbrauchen:'],
        items: [
          'Versuchen Sie nicht, die App zu dekompilieren oder zu reverse-engineeren.',
          'Laden Sie keine illegalen oder sch\u00e4dlichen Inhalte hoch.',
          'St\u00f6ren Sie nicht die Funktionalit\u00e4t der App.',
          'Verwenden Sie keine automatisierten Tools, Bots oder Scraper.',
        ],
      },
      {
        title: '6. Geistiges Eigentum',
        paragraphs: ['Die App ist geistiges Eigentum des Erstellers. Sie erhalten eine eingeschr\u00e4nkte, nicht-exklusive Lizenz f\u00fcr pers\u00f6nliche, nicht-kommerzielle Nutzung.'],
      },
      {
        title: '7. Drittanbieter-Dienste',
        paragraphs: ['Die App integriert sich mit Google Sign-In, Google Drive API und Google Gemini AI, die ihren jeweiligen Bedingungen unterliegen.'],
      },
      {
        title: '8. Haftungsausschluss',
        paragraphs: ['Die App wird "wie besehen" ohne Gew\u00e4hrleistungen bereitgestellt. Wir garantieren nicht:'],
        items: [
          'Ununterbrochenen, sicheren oder fehlerfreien Betrieb.',
          'Genauigkeit der KI-Identifizierungen oder Empfehlungen.',
          'Erhaltung der in Google Drive gespeicherten Daten.',
        ],
      },
      {
        title: '9. Haftungsbeschr\u00e4nkung',
        paragraphs: ['Wir haften nicht f\u00fcr indirekte, zuf\u00e4llige, besondere oder Folgesch\u00e4den aus der Nutzung der App.'],
      },
      {
        title: '10. \u00c4nderungen',
        paragraphs: ['Wir behalten uns das Recht vor, die App jederzeit zu \u00e4ndern. Ihre weitere Nutzung gilt als Zustimmung.'],
      },
      {
        title: '11. K\u00fcndigung',
        paragraphs: ['Sie k\u00f6nnen die Nutzung jederzeit beenden. Ihre Daten verbleiben in Ihrem Google Drive.'],
      },
      {
        title: '12. Kontakt',
        paragraphs: ['Bei Fragen kontaktieren Sie uns \u00fcber die Anwendung.'],
      },
    ],
  },
  pt: {
    title: 'Termos de Servi\u00e7o',
    effectiveDate: 'Data de Vig\u00eancia: 4 de mar\u00e7o de 2026',
    intro: 'Bem-vindo ao Meu Invent\u00e1rio Pessoal de Plantas ("o Aplicativo"). Ao acessar ou usar este aplicativo, voc\u00ea concorda em cumprir estes Termos de Servi\u00e7o. Se voc\u00ea n\u00e3o concordar, por favor n\u00e3o use o Aplicativo.',
    sections: [
      {
        title: '1. Descri\u00e7\u00e3o do Servi\u00e7o',
        paragraphs: ['Meu Invent\u00e1rio Pessoal de Plantas \u00e9 um aplicativo web gratuito que permite aos usu\u00e1rios fotografar, identificar e catalogar plantas. O Aplicativo usa a IA Google Gemini para identifica\u00e7\u00e3o de plantas e armazena todos os dados do usu\u00e1rio na pr\u00f3pria conta do Google Drive do usu\u00e1rio ou localmente em seu dispositivo.'],
      },
      {
        title: '2. Conta e Autentica\u00e7\u00e3o',
        paragraphs: ['Para usar o Aplicativo completo, voc\u00ea pode fazer login com uma conta Google. Ao fazer login, voc\u00ea autoriza o Aplicativo a:'],
        items: [
          'Acessar suas informa\u00e7\u00f5es b\u00e1sicas de perfil do Google para fins de autentica\u00e7\u00e3o.',
          'Criar e gerenciar arquivos no seu Google Drive em uma pasta chamada "PlantInventory".',
        ],
        afterItems: 'Voc\u00ea \u00e9 respons\u00e1vel por manter a seguran\u00e7a da sua conta Google.',
      },
      {
        title: '3. Armazenamento e Propriedade de Dados',
        paragraphs: ['Todos os dados e fotos de plantas s\u00e3o armazenados exclusivamente na sua conta pessoal do Google Drive ou no armazenamento local do seu navegador. N\u00e3o armazenamos seus dados de plantas ou fotos em nossos servidores. Os \u00fanicos dados que armazenamos em nossos servidores s\u00e3o:'],
        items: [
          'Suas informa\u00e7\u00f5es b\u00e1sicas de perfil (para gerenciamento de sess\u00e3o).',
          'Seus tokens OAuth do Google Drive (para manter sua conex\u00e3o com o Drive).',
        ],
        afterItems: 'Voc\u00ea mant\u00e9m total propriedade e controle de todos os seus dados e fotos de plantas em todos os momentos.',
      },
      {
        title: '4. Identifica\u00e7\u00e3o de Plantas por IA',
        paragraphs: ['O Aplicativo usa a IA Google Gemini para identificar plantas a partir de fotos. Por favor, observe:'],
        items: [
          'A identifica\u00e7\u00e3o por IA pode nem sempre ser precisa.',
          'O Aplicativo n\u00e3o garante a corre\u00e7\u00e3o das identifica\u00e7\u00f5es ou recomenda\u00e7\u00f5es de cuidado.',
          'N\u00e3o confie exclusivamente neste Aplicativo para decis\u00f5es relacionadas \u00e0 seguran\u00e7a, toxicidade ou comestibilidade de plantas.',
          'Fotos enviadas para identifica\u00e7\u00e3o s\u00e3o processadas pela API Gemini do Google.',
        ],
      },
      {
        title: '5. Uso Aceit\u00e1vel',
        paragraphs: ['Voc\u00ea concorda em usar o Aplicativo apenas para seu prop\u00f3sito pretendido. Voc\u00ea concorda em n\u00e3o:'],
        items: [
          'Tentar fazer engenharia reversa, descompilar ou desmontar o Aplicativo.',
          'Enviar conte\u00fado ilegal, prejudicial ou que viole os direitos de terceiros.',
          'Interferir ou interromper a funcionalidade do Aplicativo.',
          'Usar ferramentas automatizadas, bots ou scrapers para acessar o Aplicativo.',
        ],
      },
      {
        title: '6. Propriedade Intelectual',
        paragraphs: ['O Aplicativo, incluindo seu design, c\u00f3digo e marca (excluindo conte\u00fado gerado pelo usu\u00e1rio), \u00e9 propriedade intelectual do criador do Aplicativo. Voc\u00ea recebe uma licen\u00e7a limitada, n\u00e3o exclusiva e intransfer\u00edvel para usar o Aplicativo para fins pessoais e n\u00e3o comerciais.'],
      },
      {
        title: '7. Servi\u00e7os de Terceiros',
        paragraphs: ['O Aplicativo se integra com Google Sign-In, Google Drive API e Google Gemini AI. Seu uso desses servi\u00e7os est\u00e1 sujeito aos respectivos termos e pol\u00edticas de privacidade.'],
      },
      {
        title: '8. Isen\u00e7\u00e3o de Garantias',
        paragraphs: ['O Aplicativo \u00e9 fornecido "como est\u00e1" e "conforme dispon\u00edvel" sem garantias de qualquer tipo. N\u00e3o garantimos que:'],
        items: [
          'O Aplicativo ser\u00e1 ininterrupto, seguro ou livre de erros.',
          'As identifica\u00e7\u00f5es ou recomenda\u00e7\u00f5es de IA ser\u00e3o precisas.',
          'Os dados armazenados no seu Google Drive ser\u00e3o preservados.',
        ],
      },
      {
        title: '9. Limita\u00e7\u00e3o de Responsabilidade',
        paragraphs: ['Na m\u00e1xima extens\u00e3o permitida por lei, n\u00e3o seremos respons\u00e1veis por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos decorrentes do uso ou incapacidade de uso do Aplicativo.'],
      },
      {
        title: '10. Altera\u00e7\u00f5es',
        paragraphs: ['Reservamo-nos o direito de modificar, suspender ou descontinuar o Aplicativo a qualquer momento. Podemos atualizar estes Termos periodicamente; o uso continuado constitui aceita\u00e7\u00e3o.'],
      },
      {
        title: '11. Rescis\u00e3o',
        paragraphs: ['Voc\u00ea pode parar de usar o Aplicativo a qualquer momento. Podemos encerrar ou suspender seu acesso a nosso exclusivo crit\u00e9rio. Ap\u00f3s a rescis\u00e3o, seus dados permanecem no seu Google Drive sob seu controle.'],
      },
      {
        title: '12. Contato',
        paragraphs: ['Se voc\u00ea tiver alguma d\u00favida sobre estes Termos, entre em contato conosco atrav\u00e9s do aplicativo.'],
      },
    ],
  },
  ja: {
    title: '\u5229\u7528\u898f\u7d04',
    effectiveDate: '\u767a\u52b9\u65e5: 2026\u5e743\u67084\u65e5',
    intro: '\u79c1\u306e\u690d\u7269\u30a4\u30f3\u30d9\u30f3\u30c8\u30ea\uff08\u300c\u672c\u30a2\u30d7\u30ea\u300d\uff09\u3078\u3088\u3046\u3053\u305d\u3002\u672c\u30a2\u30d7\u30ea\u30b1\u30fc\u30b7\u30e7\u30f3\u306b\u30a2\u30af\u30bb\u30b9\u307e\u305f\u306f\u4f7f\u7528\u3059\u308b\u3053\u3068\u306b\u3088\u308a\u3001\u672c\u5229\u7528\u898f\u7d04\u306b\u540c\u610f\u3057\u305f\u3082\u306e\u3068\u307f\u306a\u3057\u307e\u3059\u3002\u540c\u610f\u3055\u308c\u306a\u3044\u5834\u5408\u306f\u3001\u672c\u30a2\u30d7\u30ea\u3092\u4f7f\u7528\u3057\u306a\u3044\u3067\u304f\u3060\u3055\u3044\u3002',
    sections: [
      {
        title: '1. \u30b5\u30fc\u30d3\u30b9\u306e\u8aac\u660e',
        paragraphs: ['\u79c1\u306e\u690d\u7269\u30a4\u30f3\u30d9\u30f3\u30c8\u30ea\u306f\u3001\u89b3\u8449\u690d\u7269\u306e\u64ae\u5f71\u3001\u8b58\u5225\u3001\u30ab\u30bf\u30ed\u30b0\u4f5c\u6210\u304c\u3067\u304d\u308b\u7121\u6599\u306eWeb\u30a2\u30d7\u30ea\u30b1\u30fc\u30b7\u30e7\u30f3\u3067\u3059\u3002Google Gemini AI\u3092\u4f7f\u7528\u3057\u3066\u690d\u7269\u3092\u8b58\u5225\u3057\u3001\u3059\u3079\u3066\u306e\u30e6\u30fc\u30b6\u30fc\u30c7\u30fc\u30bf\u306f\u30e6\u30fc\u30b6\u30fc\u81ea\u8eab\u306eGoogle Drive\u30a2\u30ab\u30a6\u30f3\u30c8\u307e\u305f\u306f\u30c7\u30d0\u30a4\u30b9\u306e\u30ed\u30fc\u30ab\u30eb\u306b\u4fdd\u5b58\u3055\u308c\u307e\u3059\u3002'],
      },
      {
        title: '2. \u30a2\u30ab\u30a6\u30f3\u30c8\u3068\u8a8d\u8a3c',
        paragraphs: ['\u30a2\u30d7\u30ea\u306e\u5168\u6a5f\u80fd\u3092\u4f7f\u7528\u3059\u308b\u306b\u306f\u3001Google\u30a2\u30ab\u30a6\u30f3\u30c8\u3067\u30b5\u30a4\u30f3\u30a4\u30f3\u3067\u304d\u307e\u3059\u3002\u30b5\u30a4\u30f3\u30a4\u30f3\u3059\u308b\u3053\u3068\u3067\u3001\u30a2\u30d7\u30ea\u306b\u4ee5\u4e0b\u3092\u8a31\u53ef\u3057\u307e\u3059\uff1a'],
        items: [
          '\u8a8d\u8a3c\u306e\u305f\u3081\u306bGoogle\u30d7\u30ed\u30d5\u30a3\u30fc\u30eb\u306e\u57fa\u672c\u60c5\u5831\u306b\u30a2\u30af\u30bb\u30b9\u3002',
          'Google Drive\u5185\u306e"PlantInventory"\u30d5\u30a9\u30eb\u30c0\u3067\u30d5\u30a1\u30a4\u30eb\u3092\u4f5c\u6210\u30fb\u7ba1\u7406\u3002',
        ],
        afterItems: 'Google\u30a2\u30ab\u30a6\u30f3\u30c8\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u7ef4\u6301\u306f\u304a\u5ba2\u69d8\u306e\u8cac\u4efb\u3068\u306a\u308a\u307e\u3059\u3002',
      },
      {
        title: '3. \u30c7\u30fc\u30bf\u306e\u4fdd\u5b58\u3068\u6240\u6709\u6a29',
        paragraphs: ['\u3059\u3079\u3066\u306e\u690d\u7269\u30c7\u30fc\u30bf\u3068\u5199\u771f\u306f\u3001\u304a\u5ba2\u69d8\u306e\u500b\u4ebaGoogle Drive\u30a2\u30ab\u30a6\u30f3\u30c8\u307e\u305f\u306f\u30d6\u30e9\u30a6\u30b6\u306e\u30ed\u30fc\u30ab\u30eb\u30b9\u30c8\u30ec\u30fc\u30b8\u306b\u306e\u307f\u4fdd\u5b58\u3055\u308c\u307e\u3059\u3002\u5f53\u793e\u306e\u30b5\u30fc\u30d0\u30fc\u306b\u4fdd\u5b58\u3059\u308b\u30c7\u30fc\u30bf\u306f\u4ee5\u4e0b\u306e\u307f\u3067\u3059\uff1a'],
        items: [
          '\u57fa\u672c\u7684\u306a\u30d7\u30ed\u30d5\u30a3\u30fc\u30eb\u60c5\u5831\uff08\u30bb\u30c3\u30b7\u30e7\u30f3\u7ba1\u7406\u7528\uff09\u3002',
          'Google Drive OAuth\u30c8\u30fc\u30af\u30f3\uff08Drive\u63a5\u7d9a\u7ef4\u6301\u7528\uff09\u3002',
        ],
        afterItems: '\u304a\u5ba2\u69d8\u306f\u3059\u3079\u3066\u306e\u690d\u7269\u30c7\u30fc\u30bf\u3068\u5199\u771f\u306e\u5b8c\u5168\u306a\u6240\u6709\u6a29\u3068\u7ba1\u7406\u6a29\u3092\u5e38\u306b\u4fdd\u6301\u3057\u307e\u3059\u3002',
      },
      {
        title: '4. AI\u690d\u7269\u8b58\u5225',
        paragraphs: ['\u672c\u30a2\u30d7\u30ea\u306fGoogle Gemini AI\u3092\u4f7f\u7528\u3057\u3066\u5199\u771f\u304b\u3089\u690d\u7269\u3092\u8b58\u5225\u3057\u307e\u3059\u3002\u4ee5\u4e0b\u306b\u3054\u6ce8\u610f\u304f\u3060\u3055\u3044\uff1a'],
        items: [
          'AI\u8b58\u5225\u306f\u5e38\u306b\u6b63\u78ba\u3068\u306f\u9650\u308a\u307e\u305b\u3093\u3002',
          '\u672c\u30a2\u30d7\u30ea\u306f\u8b58\u5225\u3084\u30b1\u30a2\u63a8\u5968\u306e\u6b63\u78ba\u6027\u3092\u4fdd\u8a3c\u3057\u307e\u305b\u3093\u3002',
          '\u690d\u7269\u306e\u5b89\u5168\u6027\u3001\u6bd2\u6027\u3001\u98df\u7528\u306b\u95a2\u3059\u308b\u5224\u65ad\u3092\u672c\u30a2\u30d7\u30ea\u306e\u307f\u306b\u4f9d\u5b58\u3057\u306a\u3044\u3067\u304f\u3060\u3055\u3044\u3002',
          '\u8b58\u5225\u306e\u305f\u3081\u306b\u9001\u4fe1\u3055\u308c\u305f\u5199\u771f\u306fGoogle\u306eGemini API\u3067\u51e6\u7406\u3055\u308c\u307e\u3059\u3002',
        ],
      },
      {
        title: '5. \u9069\u5207\u306a\u4f7f\u7528',
        paragraphs: ['\u672c\u30a2\u30d7\u30ea\u3092\u610f\u56f3\u3055\u308c\u305f\u76ee\u7684\u306e\u307f\u306b\u4f7f\u7528\u3059\u308b\u3053\u3068\u306b\u540c\u610f\u3057\u307e\u3059\u3002\u4ee5\u4e0b\u3092\u884c\u308f\u306a\u3044\u3053\u3068\u306b\u540c\u610f\u3057\u307e\u3059\uff1a'],
        items: [
          '\u30a2\u30d7\u30ea\u306e\u30ea\u30d0\u30fc\u30b9\u30a8\u30f3\u30b8\u30cb\u30a2\u30ea\u30f3\u30b0\u3001\u9006\u30b3\u30f3\u30d1\u30a4\u30eb\u3001\u9006\u30a2\u30bb\u30f3\u30d6\u30eb\u306e\u8a66\u307f\u3002',
          '\u9055\u6cd5\u3001\u6709\u5bb3\u3001\u307e\u305f\u306f\u4ed6\u8005\u306e\u6a29\u5229\u3092\u4fb5\u5bb3\u3059\u308b\u30b3\u30f3\u30c6\u30f3\u30c4\u306e\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u3002',
          '\u30a2\u30d7\u30ea\u306e\u6a5f\u80fd\u3078\u306e\u5e72\u6e09\u307e\u305f\u306f\u59a8\u5bb3\u3002',
          '\u81ea\u52d5\u5316\u30c4\u30fc\u30eb\u3001\u30dc\u30c3\u30c8\u3001\u30b9\u30af\u30ec\u30a4\u30d1\u30fc\u306e\u4f7f\u7528\u3002',
        ],
      },
      {
        title: '6. \u77e5\u7684\u8ca1\u7523',
        paragraphs: ['\u672c\u30a2\u30d7\u30ea\uff08\u30c7\u30b6\u30a4\u30f3\u3001\u30b3\u30fc\u30c9\u3001\u30d6\u30e9\u30f3\u30c7\u30a3\u30f3\u30b0\u3092\u542b\u3080\u3001\u30e6\u30fc\u30b6\u30fc\u751f\u6210\u30b3\u30f3\u30c6\u30f3\u30c4\u3092\u9664\u304f\uff09\u306f\u30a2\u30d7\u30ea\u4f5c\u6210\u8005\u306e\u77e5\u7684\u8ca1\u7523\u3067\u3059\u3002\u500b\u4eba\u7684\u306a\u975e\u5546\u7528\u76ee\u7684\u3067\u30a2\u30d7\u30ea\u3092\u4f7f\u7528\u3059\u308b\u305f\u3081\u306e\u9650\u5b9a\u7684\u3001\u975e\u72ec\u5360\u7684\u3001\u8b72\u6e21\u4e0d\u53ef\u306e\u30e9\u30a4\u30bb\u30f3\u30b9\u304c\u4ed8\u4e0e\u3055\u308c\u307e\u3059\u3002'],
      },
      {
        title: '7. \u30b5\u30fc\u30c9\u30d1\u30fc\u30c6\u30a3\u30b5\u30fc\u30d3\u30b9',
        paragraphs: ['\u672c\u30a2\u30d7\u30ea\u306fGoogle Sign-In\u3001Google Drive API\u3001Google Gemini AI\u3068\u9023\u643a\u3057\u3066\u3044\u307e\u3059\u3002\u3053\u308c\u3089\u306e\u30b5\u30fc\u30d3\u30b9\u306e\u4f7f\u7528\u306f\u305d\u308c\u305e\u308c\u306e\u5229\u7528\u898f\u7d04\u304a\u3088\u3073\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc\u306b\u5f93\u3044\u307e\u3059\u3002'],
      },
      {
        title: '8. \u4fdd\u8a3c\u306e\u5426\u8a8d',
        paragraphs: ['\u672c\u30a2\u30d7\u30ea\u306f\u300c\u73fe\u72b6\u306e\u307e\u307e\u300d\u304a\u3088\u3073\u300c\u5229\u7528\u53ef\u80fd\u306a\u72b6\u614b\u300d\u3067\u63d0\u4f9b\u3055\u308c\u3001\u3044\u304b\u306a\u308b\u4fdd\u8a3c\u3082\u3042\u308a\u307e\u305b\u3093\u3002\u4ee5\u4e0b\u3092\u4fdd\u8a3c\u3057\u307e\u305b\u3093\uff1a'],
        items: [
          '\u30a2\u30d7\u30ea\u304c\u4e2d\u65ad\u306a\u304f\u3001\u5b89\u5168\u3067\u3001\u30a8\u30e9\u30fc\u306e\u306a\u3044\u3053\u3068\u3002',
          'AI\u8b58\u5225\u3084\u30b1\u30a2\u63a8\u5968\u304c\u6b63\u78ba\u3067\u3042\u308b\u3053\u3068\u3002',
          'Google Drive\u306b\u4fdd\u5b58\u3055\u308c\u305f\u30c7\u30fc\u30bf\u304c\u4fdd\u5168\u3055\u308c\u308b\u3053\u3068\u3002',
        ],
      },
      {
        title: '9. \u8cac\u4efb\u306e\u5236\u9650',
        paragraphs: ['\u6cd5\u5f8b\u3067\u8a31\u5bb9\u3055\u308c\u308b\u6700\u5927\u9650\u5ea6\u306b\u304a\u3044\u3066\u3001\u30a2\u30d7\u30ea\u306e\u4f7f\u7528\u307e\u305f\u306f\u4f7f\u7528\u4e0d\u80fd\u306b\u8d77\u56e0\u3059\u308b\u9593\u63a5\u7684\u3001\u5076\u767a\u7684\u3001\u7279\u5225\u3001\u7d50\u679c\u7684\u3001\u307e\u305f\u306f\u61f2\u7f70\u7684\u640d\u5bb3\u306b\u3064\u3044\u3066\u3001\u5f53\u793e\u306f\u8cac\u4efb\u3092\u8ca0\u3044\u307e\u305b\u3093\u3002'],
      },
      {
        title: '10. \u5909\u66f4',
        paragraphs: ['\u5f53\u793e\u306f\u3001\u30a2\u30d7\u30ea\u3092\u3044\u3064\u3067\u3082\u5909\u66f4\u3001\u505c\u6b62\u3001\u307e\u305f\u306f\u4e2d\u6b62\u3059\u308b\u6a29\u5229\u3092\u7559\u4fdd\u3057\u307e\u3059\u3002\u672c\u898f\u7d04\u306f\u968f\u6642\u66f4\u65b0\u3055\u308c\u308b\u5834\u5408\u304c\u3042\u308a\u3001\u7d99\u7d9a\u4f7f\u7528\u306f\u627f\u8afe\u3068\u307f\u306a\u3055\u308c\u307e\u3059\u3002'],
      },
      {
        title: '11. \u7d42\u4e86',
        paragraphs: ['\u304a\u5ba2\u69d8\u306f\u3044\u3064\u3067\u3082\u30a2\u30d7\u30ea\u306e\u4f7f\u7528\u3092\u4e2d\u6b62\u3067\u304d\u307e\u3059\u3002\u5f53\u793e\u306f\u72ec\u81ea\u306e\u5224\u65ad\u3067\u30a2\u30af\u30bb\u30b9\u3092\u7d42\u4e86\u307e\u305f\u306f\u505c\u6b62\u3059\u308b\u3053\u3068\u304c\u3042\u308a\u307e\u3059\u3002\u7d42\u4e86\u5f8c\u3082\u3001\u304a\u5ba2\u69d8\u306e\u30c7\u30fc\u30bf\u306fGoogle Drive\u306b\u304a\u5ba2\u69d8\u306e\u7ba1\u7406\u4e0b\u3067\u6b8b\u308a\u307e\u3059\u3002'],
      },
      {
        title: '12. \u304a\u554f\u3044\u5408\u308f\u305b',
        paragraphs: ['\u672c\u898f\u7d04\u306b\u3064\u3044\u3066\u3054\u4e0d\u660e\u306a\u70b9\u304c\u3042\u308c\u3070\u3001\u30a2\u30d7\u30ea\u30b1\u30fc\u30b7\u30e7\u30f3\u3092\u901a\u3058\u3066\u304a\u554f\u3044\u5408\u308f\u305b\u304f\u3060\u3055\u3044\u3002'],
      },
    ],
  },
  ko: {
    title: '\uc774\uc6a9\uc57d\uad00',
    effectiveDate: '\uc2dc\ud589\uc77c: 2026\ub144 3\uc6d4 4\uc77c',
    intro: '\ub098\uc758 \uc2dd\ubb3c \uc778\ubca4\ud1a0\ub9ac("\ubcf8 \uc571")\uc5d0 \uc624\uc2e0 \uac83\uc744 \ud658\uc601\ud569\ub2c8\ub2e4. \ubcf8 \uc560\ud50c\ub9ac\ucf00\uc774\uc158\uc5d0 \uc811\uadfc\ud558\uac70\ub098 \uc0ac\uc6a9\ud568\uc73c\ub85c\uc368 \ubcf8 \uc774\uc6a9\uc57d\uad00\uc5d0 \ub3d9\uc758\ud558\ub294 \uac83\uc73c\ub85c \uac04\uc8fc\ub429\ub2c8\ub2e4. \ub3d9\uc758\ud558\uc9c0 \uc54a\uc73c\uc2dc\uba74 \ubcf8 \uc571\uc744 \uc0ac\uc6a9\ud558\uc9c0 \ub9c8\uc138\uc694.',
    sections: [
      {
        title: '1. \uc11c\ube44\uc2a4 \uc124\uba85',
        paragraphs: ['\ub098\uc758 \uc2dd\ubb3c \uc778\ubca4\ud1a0\ub9ac\ub294 \uc0ac\uc6a9\uc790\uac00 \uc2dd\ubb3c\uc744 \ucd2c\uc601\ud558\uace0, \uc2dd\ubcc4\ud558\uace0, \uce74\ud0c8\ub85c\uadf8\ud654\ud560 \uc218 \uc788\ub294 \ubb34\ub8cc \uc6f9 \uc560\ud50c\ub9ac\ucf00\uc774\uc158\uc785\ub2c8\ub2e4. Google Gemini AI\ub97c \uc0ac\uc6a9\ud558\uc5ec \uc2dd\ubb3c\uc744 \uc2dd\ubcc4\ud558\uba70 \ubaa8\ub4e0 \uc0ac\uc6a9\uc790 \ub370\uc774\ud130\ub294 \uc0ac\uc6a9\uc790\uc758 Google Drive \uacc4\uc815 \ub610\ub294 \uae30\uae30 \ub85c\uceec\uc5d0 \uc800\uc7a5\ub429\ub2c8\ub2e4.'],
      },
      {
        title: '2. \uacc4\uc815 \ubc0f \uc778\uc99d',
        paragraphs: ['\uc571\uc758 \ubaa8\ub4e0 \uae30\ub2a5\uc744 \uc0ac\uc6a9\ud558\ub824\uba74 Google \uacc4\uc815\uc73c\ub85c \ub85c\uadf8\uc778\ud560 \uc218 \uc788\uc2b5\ub2c8\ub2e4. \ub85c\uadf8\uc778\ud558\uba74 \uc571\uc5d0 \ub2e4\uc74c\uc744 \ud5c8\uc6a9\ud569\ub2c8\ub2e4:'],
        items: [
          '\uc778\uc99d\uc744 \uc704\ud574 Google \ud504\ub85c\ud544 \uae30\ubcf8 \uc815\ubcf4\uc5d0 \uc561\uc138\uc2a4.',
          'Google Drive\uc758 "PlantInventory" \ud3f4\ub354\uc5d0\uc11c \ud30c\uc77c \uc0dd\uc131 \ubc0f \uad00\ub9ac.',
        ],
        afterItems: 'Google \uacc4\uc815\uc758 \ubcf4\uc548 \uc720\uc9c0\ub294 \uadc0\ud558\uc758 \ucc45\uc784\uc785\ub2c8\ub2e4.',
      },
      {
        title: '3. \ub370\uc774\ud130 \uc800\uc7a5 \ubc0f \uc18c\uc720\uad8c',
        paragraphs: ['\ubaa8\ub4e0 \uc2dd\ubb3c \ub370\uc774\ud130\uc640 \uc0ac\uc9c4\uc740 \uadc0\ud558\uc758 \uac1c\uc778 Google Drive \uacc4\uc815 \ub610\ub294 \ube0c\ub77c\uc6b0\uc800 \ub85c\uceec \uc800\uc7a5\uc18c\uc5d0\ub9cc \uc800\uc7a5\ub429\ub2c8\ub2e4. \ub2f9\uc0ac \uc11c\ubc84\uc5d0 \uc800\uc7a5\ud558\ub294 \uc720\uc77c\ud55c \ub370\uc774\ud130\ub294:'],
        items: [
          '\uae30\ubcf8 \ud504\ub85c\ud544 \uc815\ubcf4(\uc138\uc158 \uad00\ub9ac\uc6a9).',
          'Google Drive OAuth \ud1a0\ud070(Drive \uc5f0\uacb0 \uc720\uc9c0\uc6a9).',
        ],
        afterItems: '\uadc0\ud558\ub294 \ud56d\uc0c1 \ubaa8\ub4e0 \uc2dd\ubb3c \ub370\uc774\ud130\uc640 \uc0ac\uc9c4\uc758 \uc644\uc804\ud55c \uc18c\uc720\uad8c\uacfc \uad00\ub9ac\uad8c\uc744 \ubcf4\uc720\ud569\ub2c8\ub2e4.',
      },
      {
        title: '4. AI \uc2dd\ubb3c \uc2dd\ubcc4',
        paragraphs: ['\ubcf8 \uc571\uc740 Google Gemini AI\ub97c \uc0ac\uc6a9\ud558\uc5ec \uc0ac\uc9c4\uc5d0\uc11c \uc2dd\ubb3c\uc744 \uc2dd\ubcc4\ud569\ub2c8\ub2e4. \ub2e4\uc74c\uc744 \uc720\uc758\ud558\uc138\uc694:'],
        items: [
          'AI \uc2dd\ubcc4\uc774 \ud56d\uc0c1 \uc815\ud655\ud558\uc9c0 \uc54a\uc744 \uc218 \uc788\uc2b5\ub2c8\ub2e4.',
          '\ubcf8 \uc571\uc740 \uc2dd\ubcc4 \ub610\ub294 \uad00\ub9ac \uad8c\uc7a5 \uc0ac\ud56d\uc758 \uc815\ud655\uc131\uc744 \ubcf4\uc7a5\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4.',
          '\uc2dd\ubb3c \uc548\uc804, \ub3c5\uc131 \ub610\ub294 \uc2dd\uc6a9 \uad00\ub828 \uacb0\uc815\uc744 \ubcf8 \uc571\uc5d0\ub9cc \uc758\uc874\ud558\uc9c0 \ub9c8\uc138\uc694.',
          '\uc2dd\ubcc4\uc744 \uc704\ud574 \uc81c\ucd9c\ub41c \uc0ac\uc9c4\uc740 Google Gemini API\ub85c \ucc98\ub9ac\ub429\ub2c8\ub2e4.',
        ],
      },
      {
        title: '5. \ud5c8\uc6a9\ub418\ub294 \uc0ac\uc6a9',
        paragraphs: ['\ubcf8 \uc571\uc744 \uc758\ub3c4\ub41c \ubaa9\uc801\uc73c\ub85c\ub9cc \uc0ac\uc6a9\ud558\ub294 \ub370 \ub3d9\uc758\ud569\ub2c8\ub2e4. \ub2e4\uc74c\uc744 \ud558\uc9c0 \uc54a\ub294 \ub370 \ub3d9\uc758\ud569\ub2c8\ub2e4:'],
        items: [
          '\uc571\uc744 \ub9ac\ubc84\uc2a4 \uc5d4\uc9c0\ub2c8\uc5b4\ub9c1, \ub514\ucef4\ud30c\uc77c \ub610\ub294 \ub514\uc2a4\uc5b4\uc148\ube14\ud558\ub294 \uc2dc\ub3c4.',
          '\ubd88\ubc95\uc801\uc774\uac70\ub098, \uc720\ud574\ud558\uac70\ub098, \ud0c0\uc778\uc758 \uad8c\ub9ac\ub97c \uce68\ud574\ud558\ub294 \ucf58\ud150\uce20 \uc5c5\ub85c\ub4dc.',
          '\uc571\uc758 \uae30\ub2a5\uc5d0 \uac04\uc12d\ud558\uac70\ub098 \ubc29\ud574.',
          '\uc790\ub3d9\ud654 \ub3c4\uad6c, \ubd07 \ub610\ub294 \uc2a4\ud06c\ub808\uc774\ud37c\ub97c \uc0ac\uc6a9\ud558\uc5ec \uc571\uc5d0 \uc561\uc138\uc2a4.',
        ],
      },
      {
        title: '6. \uc9c0\uc801 \uc7ac\uc0b0\uad8c',
        paragraphs: ['\ubcf8 \uc571(\ub514\uc790\uc778, \ucf54\ub4dc, \ube0c\ub79c\ub529 \ud3ec\ud568, \uc0ac\uc6a9\uc790 \uc0dd\uc131 \ucf58\ud150\uce20 \uc81c\uc678)\uc740 \uc571 \uc81c\uc791\uc790\uc758 \uc9c0\uc801 \uc7ac\uc0b0\uc785\ub2c8\ub2e4. \uac1c\uc778\uc801, \ube44\uc0c1\uc5c5\uc801 \ubaa9\uc801\uc73c\ub85c \uc571\uc744 \uc0ac\uc6a9\ud560 \uc218 \uc788\ub294 \uc81c\ud55c\uc801\uc774\uace0 \ube44\ub3c5\uc810\uc801\uc774\uba70 \uc591\ub3c4\ud560 \uc218 \uc5c6\ub294 \ub77c\uc774\uc120\uc2a4\uac00 \ubd80\uc5ec\ub429\ub2c8\ub2e4.'],
      },
      {
        title: '7. \uc81c3\uc790 \uc11c\ube44\uc2a4',
        paragraphs: ['\ubcf8 \uc571\uc740 Google Sign-In, Google Drive API, Google Gemini AI\uc640 \ud1b5\ud569\ub429\ub2c8\ub2e4. \uc774\ub7ec\ud55c \uc11c\ube44\uc2a4\uc758 \uc0ac\uc6a9\uc740 \ud574\ub2f9 \uc774\uc6a9\uc57d\uad00 \ubc0f \uac1c\uc778\uc815\ubcf4 \ucc98\ub9ac\ubc29\uce68\uc758 \uc801\uc6a9\uc744 \ubc1b\uc2b5\ub2c8\ub2e4.'],
      },
      {
        title: '8. \ubcf4\uc99d \ubd80\uc778',
        paragraphs: ['\ubcf8 \uc571\uc740 \uc5b4\ub5a0\ud55c \uc885\ub958\uc758 \ubcf4\uc99d \uc5c6\uc774 "\uc788\ub294 \uadf8\ub300\ub85c" \ubc0f "\uc0ac\uc6a9 \uac00\ub2a5\ud55c \ub300\ub85c" \uc81c\uacf5\ub429\ub2c8\ub2e4. \ub2e4\uc74c\uc744 \ubcf4\uc7a5\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4:'],
        items: [
          '\uc571\uc774 \uc911\ub2e8 \uc5c6\uc774, \uc548\uc804\ud558\uac8c, \uc624\ub958 \uc5c6\uc774 \uc791\ub3d9\ud560 \uac83.',
          'AI \uc2dd\ubcc4 \ub610\ub294 \uad00\ub9ac \uad8c\uc7a5 \uc0ac\ud56d\uc774 \uc815\ud655\ud560 \uac83.',
          'Google Drive\uc5d0 \uc800\uc7a5\ub41c \ub370\uc774\ud130\uac00 \ubcf4\uc874\ub420 \uac83.',
        ],
      },
      {
        title: '9. \ucc45\uc784 \uc81c\ud55c',
        paragraphs: ['\ubc95\ub960\uc774 \ud5c8\uc6a9\ud558\ub294 \ucd5c\ub300 \ubc94\uc704\uc5d0\uc11c \uc571\uc758 \uc0ac\uc6a9 \ub610\ub294 \uc0ac\uc6a9 \ubd88\uac00\ub85c \uc778\ud55c \uac04\uc811\uc801, \ubd80\uc218\uc801, \ud2b9\ubcc4, \uacb0\uacfc\uc801 \ub610\ub294 \uc9d5\ubc8c\uc801 \uc190\ud574\uc5d0 \ub300\ud574 \ucc45\uc784\uc744 \uc9c0\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4.'],
      },
      {
        title: '10. \ubcc0\uacbd',
        paragraphs: ['\ub2f9\uc0ac\ub294 \uc5b8\uc81c\ub4e0\uc9c0 \uc571\uc744 \uc218\uc815, \uc911\ub2e8 \ub610\ub294 \uc911\uc9c0\ud560 \uad8c\ub9ac\ub97c \ubcf4\uc720\ud569\ub2c8\ub2e4. \ubcf8 \uc57d\uad00\uc744 \uc218\uc2dc\ub85c \uc5c5\ub370\uc774\ud2b8\ud560 \uc218 \uc788\uc73c\uba70, \uacc4\uc18d \uc0ac\uc6a9\uc740 \ub3d9\uc758\ub85c \uac04\uc8fc\ub429\ub2c8\ub2e4.'],
      },
      {
        title: '11. \ud574\uc9c0',
        paragraphs: ['\uadc0\ud558\ub294 \uc5b8\uc81c\ub4e0\uc9c0 \uc571 \uc0ac\uc6a9\uc744 \uc911\ub2e8\ud560 \uc218 \uc788\uc2b5\ub2c8\ub2e4. \ub2f9\uc0ac\ub294 \ub2e8\ub3c5 \uc7ac\ub7c9\uc73c\ub85c \uc561\uc138\uc2a4\ub97c \uc885\ub8cc\ud558\uac70\ub098 \uc77c\uc2dc \uc911\uc9c0\ud560 \uc218 \uc788\uc2b5\ub2c8\ub2e4. \ud574\uc9c0 \ud6c4 \uadc0\ud558\uc758 \ub370\uc774\ud130\ub294 \uadc0\ud558\uc758 \uad00\ub9ac \ud558\uc5d0 Google Drive\uc5d0 \ub0a8\uc544 \uc788\uc2b5\ub2c8\ub2e4.'],
      },
      {
        title: '12. \ubb38\uc758',
        paragraphs: ['\ubcf8 \uc57d\uad00\uc5d0 \ub300\ud574 \ubb38\uc758\uc0ac\ud56d\uc774 \uc788\uc73c\uc2dc\uba74 \uc560\ud50c\ub9ac\ucf00\uc774\uc158\uc744 \ud1b5\ud574 \uc5f0\ub77d\ud574 \uc8fc\uc138\uc694.'],
      },
    ],
  },
  zh: {
    title: '\u670d\u52a1\u6761\u6b3e',
    effectiveDate: '\u751f\u6548\u65e5\u671f: 2026\u5e743\u67084\u65e5',
    intro: '\u6b22\u8fce\u4f7f\u7528\u6211\u7684\u690d\u7269\u6e05\u5355\uff08\u201c\u672c\u5e94\u7528\u201d\uff09\u3002\u901a\u8fc7\u8bbf\u95ee\u6216\u4f7f\u7528\u672c\u5e94\u7528\u7a0b\u5e8f\uff0c\u60a8\u540c\u610f\u53d7\u672c\u670d\u52a1\u6761\u6b3e\u7684\u7ea6\u675f\u3002\u5982\u679c\u60a8\u4e0d\u540c\u610f\uff0c\u8bf7\u4e0d\u8981\u4f7f\u7528\u672c\u5e94\u7528\u3002',
    sections: [
      {
        title: '1. \u670d\u52a1\u63cf\u8ff0',
        paragraphs: ['\u6211\u7684\u690d\u7269\u6e05\u5355\u662f\u4e00\u6b3e\u514d\u8d39\u7684\u7f51\u7edc\u5e94\u7528\u7a0b\u5e8f\uff0c\u5141\u8bb8\u7528\u6237\u62cd\u6444\u3001\u8bc6\u522b\u548c\u7f16\u76ee\u5ba4\u5185\u690d\u7269\u3002\u672c\u5e94\u7528\u4f7f\u7528Google Gemini AI\u8fdb\u884c\u690d\u7269\u8bc6\u522b\uff0c\u5e76\u5c06\u6240\u6709\u7528\u6237\u6570\u636e\u5b58\u50a8\u5728\u7528\u6237\u81ea\u5df1\u7684Google Drive\u8d26\u6237\u6216\u8bbe\u5907\u672c\u5730\u3002'],
      },
      {
        title: '2. \u8d26\u6237\u548c\u8eab\u4efd\u9a8c\u8bc1',
        paragraphs: ['\u8981\u4f7f\u7528\u5e94\u7528\u7684\u5168\u90e8\u529f\u80fd\uff0c\u60a8\u53ef\u4ee5\u4f7f\u7528Google\u8d26\u6237\u767b\u5f55\u3002\u767b\u5f55\u540e\uff0c\u60a8\u6388\u6743\u5e94\u7528\uff1a'],
        items: [
          '\u8bbf\u95ee\u60a8\u7684\u57fa\u672cGoogle\u4e2a\u4eba\u8d44\u6599\u4fe1\u606f\u7528\u4e8e\u8eab\u4efd\u9a8c\u8bc1\u3002',
          '\u5728\u60a8\u7684Google Drive\u4e2d\u540d\u4e3a"PlantInventory"\u7684\u6587\u4ef6\u5939\u5185\u521b\u5efa\u548c\u7ba1\u7406\u6587\u4ef6\u3002',
        ],
        afterItems: '\u60a8\u6709\u8d23\u4efb\u7ef4\u62a4\u60a8\u7684Google\u8d26\u6237\u5b89\u5168\u3002',
      },
      {
        title: '3. \u6570\u636e\u5b58\u50a8\u548c\u6240\u6709\u6743',
        paragraphs: ['\u6240\u6709\u690d\u7269\u6570\u636e\u548c\u7167\u7247\u4ec5\u5b58\u50a8\u5728\u60a8\u7684\u4e2a\u4ebaGoogle Drive\u8d26\u6237\u6216\u6d4f\u89c8\u5668\u672c\u5730\u5b58\u50a8\u4e2d\u3002\u6211\u4eec\u4e0d\u4f1a\u5728\u670d\u52a1\u5668\u4e0a\u5b58\u50a8\u60a8\u7684\u690d\u7269\u6570\u636e\u6216\u7167\u7247\u3002\u6211\u4eec\u5728\u670d\u52a1\u5668\u4e0a\u5b58\u50a8\u7684\u552f\u4e00\u6570\u636e\u662f\uff1a'],
        items: [
          '\u60a8\u7684\u57fa\u672c\u4e2a\u4eba\u8d44\u6599\u4fe1\u606f\uff08\u7528\u4e8e\u4f1a\u8bdd\u7ba1\u7406\uff09\u3002',
          '\u60a8\u7684Google Drive OAuth\u4ee4\u724c\uff08\u7528\u4e8e\u7ef4\u6301Drive\u8fde\u63a5\uff09\u3002',
        ],
        afterItems: '\u60a8\u59cb\u7ec8\u4fdd\u6709\u6240\u6709\u690d\u7269\u6570\u636e\u548c\u7167\u7247\u7684\u5b8c\u5168\u6240\u6709\u6743\u548c\u63a7\u5236\u6743\u3002',
      },
      {
        title: '4. AI\u690d\u7269\u8bc6\u522b',
        paragraphs: ['\u672c\u5e94\u7528\u4f7f\u7528Google Gemini AI\u4ece\u7167\u7247\u4e2d\u8bc6\u522b\u690d\u7269\u3002\u8bf7\u6ce8\u610f\uff1a'],
        items: [
          'AI\u8bc6\u522b\u53ef\u80fd\u5e76\u4e0d\u603b\u662f\u51c6\u786e\u7684\u3002',
          '\u672c\u5e94\u7528\u4e0d\u4fdd\u8bc1\u8bc6\u522b\u6216\u62a4\u7406\u5efa\u8bae\u7684\u6b63\u786e\u6027\u3002',
          '\u4e0d\u8981\u4ec5\u4f9d\u8d56\u672c\u5e94\u7528\u505a\u51fa\u5173\u4e8e\u690d\u7269\u5b89\u5168\u3001\u6bd2\u6027\u6216\u53ef\u98df\u6027\u7684\u51b3\u5b9a\u3002',
          '\u63d0\u4ea4\u8bc6\u522b\u7684\u7167\u7247\u7531Google Gemini API\u5904\u7406\u3002',
        ],
      },
      {
        title: '5. \u53ef\u63a5\u53d7\u7684\u4f7f\u7528',
        paragraphs: ['\u60a8\u540c\u610f\u4ec5\u5c06\u672c\u5e94\u7528\u7528\u4e8e\u5176\u9884\u5b9a\u7528\u9014\u3002\u60a8\u540c\u610f\u4e0d\u4f1a\uff1a'],
        items: [
          '\u5c1d\u8bd5\u5bf9\u5e94\u7528\u8fdb\u884c\u9006\u5411\u5de5\u7a0b\u3001\u53cd\u7f16\u8bd1\u6216\u53cd\u6c47\u7f16\u3002',
          '\u4e0a\u4f20\u8fdd\u6cd5\u3001\u6709\u5bb3\u6216\u4fb5\u72af\u4ed6\u4eba\u6743\u5229\u7684\u5185\u5bb9\u3002',
          '\u5e72\u6270\u6216\u7834\u574f\u5e94\u7528\u7684\u529f\u80fd\u3002',
          '\u4f7f\u7528\u81ea\u52a8\u5316\u5de5\u5177\u3001\u673a\u5668\u4eba\u6216\u722c\u866b\u8bbf\u95ee\u5e94\u7528\u3002',
        ],
      },
      {
        title: '6. \u77e5\u8bc6\u4ea7\u6743',
        paragraphs: ['\u672c\u5e94\u7528\uff08\u5305\u62ec\u5176\u8bbe\u8ba1\u3001\u4ee3\u7801\u548c\u54c1\u724c\uff0c\u4e0d\u5305\u62ec\u7528\u6237\u751f\u6210\u7684\u5185\u5bb9\uff09\u662f\u5e94\u7528\u521b\u5efa\u8005\u7684\u77e5\u8bc6\u4ea7\u6743\u3002\u60a8\u83b7\u5f97\u4e00\u4e2a\u6709\u9650\u7684\u3001\u975e\u72ec\u5360\u7684\u3001\u4e0d\u53ef\u8f6c\u8ba9\u7684\u8bb8\u53ef\u8bc1\uff0c\u7528\u4e8e\u4e2a\u4eba\u975e\u5546\u4e1a\u76ee\u7684\u4f7f\u7528\u672c\u5e94\u7528\u3002'],
      },
      {
        title: '7. \u7b2c\u4e09\u65b9\u670d\u52a1',
        paragraphs: ['\u672c\u5e94\u7528\u4e0eGoogle Sign-In\u3001Google Drive API\u548cGoogle Gemini AI\u96c6\u6210\u3002\u60a8\u5bf9\u8fd9\u4e9b\u670d\u52a1\u7684\u4f7f\u7528\u53d7\u5176\u5404\u81ea\u7684\u6761\u6b3e\u548c\u9690\u79c1\u653f\u7b56\u7ea6\u675f\u3002'],
      },
      {
        title: '8. \u514d\u8d23\u58f0\u660e',
        paragraphs: ['\u672c\u5e94\u7528\u6309\u201c\u539f\u6837\u201d\u548c\u201c\u53ef\u7528\u201d\u63d0\u4f9b\uff0c\u4e0d\u63d0\u4f9b\u4efb\u4f55\u4fdd\u8bc1\u3002\u6211\u4eec\u4e0d\u4fdd\u8bc1\uff1a'],
        items: [
          '\u5e94\u7528\u5c06\u4e0d\u95f4\u65ad\u3001\u5b89\u5168\u6216\u65e0\u9519\u8bef\u5730\u8fd0\u884c\u3002',
          'AI\u8bc6\u522b\u6216\u62a4\u7406\u5efa\u8bae\u5c06\u662f\u51c6\u786e\u7684\u3002',
          '\u5b58\u50a8\u5728Google Drive\u4e2d\u7684\u6570\u636e\u5c06\u88ab\u4fdd\u5168\u3002',
        ],
      },
      {
        title: '9. \u8d23\u4efb\u9650\u5236',
        paragraphs: ['\u5728\u6cd5\u5f8b\u5141\u8bb8\u7684\u6700\u5927\u8303\u56f4\u5185\uff0c\u6211\u4eec\u4e0d\u5bf9\u56e0\u4f7f\u7528\u6216\u65e0\u6cd5\u4f7f\u7528\u672c\u5e94\u7528\u800c\u4ea7\u751f\u7684\u4efb\u4f55\u95f4\u63a5\u3001\u9644\u5e26\u3001\u7279\u6b8a\u3001\u540e\u679c\u6027\u6216\u60e9\u7f5a\u6027\u635f\u5bb3\u627f\u62c5\u8d23\u4efb\u3002'],
      },
      {
        title: '10. \u53d8\u66f4',
        paragraphs: ['\u6211\u4eec\u4fdd\u7559\u968f\u65f6\u4fee\u6539\u3001\u6682\u505c\u6216\u505c\u6b62\u672c\u5e94\u7528\u7684\u6743\u5229\u3002\u6211\u4eec\u53ef\u80fd\u4f1a\u4e0d\u65f6\u66f4\u65b0\u672c\u6761\u6b3e\uff1b\u7ee7\u7eed\u4f7f\u7528\u5373\u8868\u793a\u63a5\u53d7\u3002'],
      },
      {
        title: '11. \u7ec8\u6b62',
        paragraphs: ['\u60a8\u53ef\u4ee5\u968f\u65f6\u505c\u6b62\u4f7f\u7528\u672c\u5e94\u7528\u3002\u6211\u4eec\u53ef\u80fd\u4f1a\u81ea\u884c\u51b3\u5b9a\u7ec8\u6b62\u6216\u6682\u505c\u60a8\u7684\u8bbf\u95ee\u3002\u7ec8\u6b62\u540e\uff0c\u60a8\u7684\u6570\u636e\u4ecd\u5728\u60a8\u7684Google Drive\u4e2d\uff0c\u7531\u60a8\u63a7\u5236\u3002'],
      },
      {
        title: '12. \u8054\u7cfb\u6211\u4eec',
        paragraphs: ['\u5982\u679c\u60a8\u5bf9\u672c\u6761\u6b3e\u6709\u4efb\u4f55\u7591\u95ee\uff0c\u8bf7\u901a\u8fc7\u5e94\u7528\u7a0b\u5e8f\u4e0e\u6211\u4eec\u8054\u7cfb\u3002'],
      },
    ],
  },
};

export default termsContent;
